<template>
  <div>
    <div>
      <h5 class="card-title">
        <!-- {{tower}} -->
        <b-row v-if="tower.stageType == 1">
          <b-col>
            <div>#{{ item.id }}</div>
          </b-col>
          <b-col>
            <div class="time">
              <div class="d-inline ml-1">
                <i class="tim-icons icon-time-alarm"></i>
              </div>
              <div class="d-inline pt-3">
                {{ item.elapsedTime }}
              </div>
            </div></b-col
          >
        </b-row>
      </h5>
      <div class="cardText" v-for="field in item.text" :key="field.text">
        <workflow-kanban-card-item :item="item" :tower="tower" :field="field" />
      </div>

      <slot name="card-buttons" v-bind:item="item"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkflowKanbanCard",
  components: {
    "workflow-kanban-card-item": () =>
      import("@/components_rms/workflow/Kanban/WorkflowKanbanCardItem.vue"),
  },
  props: ["item", "tower"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  methods: {
    openNextStage() {
      this.$refs.kanbanEditModal.show();
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>


<style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.route {
  color: white !important;
}
</style>